<script lang="ts" generics="ITEM">
    import type {RecordSearchParams} from 'src/typings';
    import {getSearchContext} from '../kp-search-context/search-context';
    import {getSearchToolbarContext} from 'src/features/search/kp-search-toolbar/search-toolbar.context';
    import {exists} from 'shared/utils/custom-utils';
    import {onDestroy} from 'svelte';
    import KpSearchBar from 'shared/ui-widgets/search/KpSearchBar.svelte';
    import SearchToolbarSection from './SearchToolbarSection.svelte';

    const searchManager = getSearchContext<ITEM, RecordSearchParams>();
    const searchManagerState = searchManager.getState$();
    const searchToolbarContext = getSearchToolbarContext();

    let lastSearchQuery: string | null = null;
    const lastSearchQuerySubscription = searchToolbarContext.lastSearchQuery$.subscribe((lastQuery) => {
        lastSearchQuery = lastQuery;
    });

    onDestroy(() => {
        lastSearchQuerySubscription();
    });

    const handleSearch = (event: CustomEvent<string>) => {
        searchManager.newSearchWithPartialParams({q: event.detail});
        searchToolbarContext.updateLastSearchQuery(event.detail);
    };

    const handleReset = () => {
        searchManager.newSearchWithPartialParams({q: null});
        searchToolbarContext.updateLastSearchQuery(null);
    };
</script>

<SearchToolbarSection additionalClasses="search-toolbar-searchbar">
    <KpSearchBar placeholder="{exists(lastSearchQuery) ? `Vyhledáno: ${lastSearchQuery}` : 'Hledat mezi daty...'}"
                 searchQuery={$searchManagerState.frontendParams.q}
                 additionalClasses={exists(lastSearchQuery) ? 'search-active' : ''}
                 buttonColorAccented={false}
                 width="100%"
                 height="20px"
                 searchIconSize="12px"
                 resetIconSize="12px"
                 forceResetButton={exists(lastSearchQuery)}
                 on:search={handleSearch}
                 on:reset={handleReset}/>
</SearchToolbarSection>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    :global {
        .search-toolbar-searchbar .kp-search-bar {
            flex-direction: row-reverse;
            align-items: center;
            outline-offset: 1px;
            outline: 1px solid @themed-border-muted;
            border-radius: @border-radius-sm;
            padding: 0 @spacing-xs;
            transition: outline-color 0.3s ease-in-out;

            &.search-active {
                outline-color: var(--accent-blue);

                .search-input::placeholder {
                    color: var(--accent-blue);
                    opacity: 0.6;
                }
            }

            .search-input, .submit-button {
                border: none !important;
            }

            .search-input {
                padding: 0 @spacing-s !important;
                padding-right: @spacing-xl !important;
            }

            .submit-button {
                border-radius: @border-radius-default !important;
                width: 16px !important;
                height: 20px !important;

                .uicon {
                    font-size: 13px;
                    color: @themed-text-muted;
                }
            }

            .reset-button {
                right: 0 !important;
            }
        }
    }
</style>